import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import searchService from "../../api/searchServices";

export const filterCity = createAsyncThunk(
  "search/filterCity",
  async (payload = {}, { rejectWithValue }) => {
    try {
      const { page = 1, per_page = 12, append = false, ...rest } = payload;

      const requestData = { page, per_page, ...rest };
      const response = await searchService.filterCity(requestData);

      const filterResult = response?.data?.data?.filterResult || {};
      const usage = response?.data?.data?.usage || null;

      return {
        cities: filterResult.data || [],
        total: filterResult.total || 0,
        page: filterResult.page || 1,
        per_page: filterResult.length || per_page,
        usage,
        append,
      };
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const getCity = createAsyncThunk(
  "search/getCity",
  async (payload = {}, { rejectWithValue }) => {
    try {
      const { id } = payload;
      if (!id) throw new Error("City 'id' is required for getCity.");

      const response = await searchService.getCityDetails({ id });

      const data = response?.data?.data || {};

      return {
        cityDetails: data || {},
      };
    } catch (error) {
      console.log("getCityDetails catch === ", error);
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const getSchools = createAsyncThunk(
  "search/getSchools",
  async (payload = {}, { rejectWithValue }) => {
    try {
      const { state, city, level_codes } = payload;

      const requestData = { state, city, level_codes };
      const response = await searchService.getSchoolData(requestData);

      const rawData = response?.data?.data || [];

      return {
        SchoolDetails: rawData || {},
      };
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);
export const getPublicSchoolData = createAsyncThunk(
  "search/getPublicSchoolData",
  async (payload = {}, { rejectWithValue }) => {
    try {
      const { state, city, level_codes } = payload;

      const requestData = { state, city, level_codes };
      const response = await searchService.getPublicSchoolData(requestData);

      const rawData = response?.data?.data || [];

      return {
        SchoolDetails: rawData || {},
      };
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const checkFilterCityCount = createAsyncThunk(
  "search/checkFilterCityCount",
  async (payload = {}, { rejectWithValue }) => {
    try {
      const response = await searchService?.checkFilterCity(payload);
      const rawData = response?.data || [];

      return {
        checkFilterCityCountData: rawData || {},
        actionFlag: "CHECK_FILTER_CITY_COUNT_SUCCESS",
        successMessage: response?.data?.message || "Success",
        error: response?.data?.error || false,
      };
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);
export const checkCitySearch = createAsyncThunk(
  "search/checkCitySearch",
  async (payload = {}, { rejectWithValue }) => {
    try {
      const response = await searchService?.checkCitySearch(payload);
      return {
        checkCitySearchData: response?.data || {},
      };
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);
export const searchSessionId = createAsyncThunk(
  "search/searchSessionId",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await searchService.searchSessionId(payload);
      return response?.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);
export const searchAnalytics = createAsyncThunk(
  "search/searchAnalytics",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await searchService.searchAnalytics(payload);
      return response?.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);
export const trackCityClick = createAsyncThunk(
  "search/trackCityClick",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await searchService.trackSearchCityClick(payload);
      return response?.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);
export const searchSessionEnd = createAsyncThunk(
  "search/searchSessionEnd",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await searchService.searchSessionEnd(payload);
      return response?.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);
export const searchBookmark = createAsyncThunk(
  "search/searchBookmark",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await searchService.searchBookmark(payload);
      return response?.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const checkMultipleBookmarks = createAsyncThunk(
  "search/checkMultipleBookmarks",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await searchService.checkMultipleBookmarks(payload);
      return response?.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const getBookmarks = createAsyncThunk(
  "search/getBookmarks",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await searchService.getBookmarks(payload);
      return response?.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const cityAutocomplete = createAsyncThunk(
  "search/cityAutocomplete",
  async (payload = {}, { rejectWithValue }) => {
    try {
      const response = await searchService.cityAutocomplete(payload);
      return response?.data?.data?.suggestions || [];
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const getCitySpotlight = createAsyncThunk(
  "search/getCitySpotlight",
  async (_, { rejectWithValue }) => {
    try {
      const response = await searchService.getCitySpotlight();
      return response?.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

const initialState = {
  cityItems: { cities: [], total: 0 },
  getCityItems: {},
  filterCityUsage: null,
  checkFilterCityCountData: {},
  selectedCityData: {},
  searchSessionIdItems: {},
  searchBookmarkItems: {},
  checkMultipleBookmarksItems: {},
  getBookmarksItems: {},
  searchAnalyticsItems: {},
  trackCityClickItems: {},
  searchSessionEndItems: {},

  isLoading: false,
  isError: false,
  errorMessage: "",
  schools: [],
  PublicSchoolData: [],
  schoolsLoading: false,
  schoolsError: null,
  analytics: {
    filterCountLoading: false,
    pieCountLoading: false,
    activityLoading: false,
  },
};

const searchSlice = createSlice({
  name: "search",
  initialState,
  reducers: {
    resetSearchState: (state) => {
      state.cityItems = { cities: [], total: 0 };
      state.isLoading = false;
      state.isError = false;
      state.errorMessage = "";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(filterCity.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(filterCity.fulfilled, (state, action) => {
        state.isLoading = false;
        const { cities, total, append, usage } = action.payload;

        if (append && state.cityItems?.cities?.length) {
          state.cityItems.cities = [...state.cityItems.cities, ...cities];
        } else {
          state.cityItems = { cities, total };
        }

        if (usage !== undefined) {
          state.filterCityUsage = usage;
        }
      })
      .addCase(filterCity.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.errorMessage = action.payload || "Something went wrong.";
      })
      .addCase(getCity.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getCity.fulfilled, (state, action) => {
        state.isLoading = false;
        state.selectedCityData = action.payload.cityDetails || {};
      })
      .addCase(getCity.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.errorMessage = action.payload || "Failed to fetch city details.";
        state.actionFlag = "GET_CITY_FAILED";
      })
      // Schools async thunk handlers
      .addCase(getSchools.pending, (state) => {
        state.schoolsLoading = true;
        state.schoolsError = null;
      })
      .addCase(getSchools.fulfilled, (state, action) => {
        state.schoolsLoading = false;
        state.schools = action.payload.SchoolDetails || [];
      })
      .addCase(getSchools.rejected, (state, action) => {
        state.schoolsLoading = false;
        state.schoolsError = action.payload || "Failed to fetch schools";
      })
      .addCase(getPublicSchoolData.pending, (state) => {
        state.schoolsLoading = true;
        state.schoolsError = null;
      })
      .addCase(getPublicSchoolData.fulfilled, (state, action) => {
        state.schoolsLoading = false;
        state.PublicSchoolData = action.payload.SchoolDetails || [];
      })
      .addCase(getPublicSchoolData.rejected, (state, action) => {
        state.schoolsLoading = false;
        state.schoolsError = action.payload || "Failed to fetch schools";
      })
      .addCase(checkFilterCityCount.pending, (state) => {
        state.schoolsLoading = true;
        state.schoolsError = null;
      })
      .addCase(checkFilterCityCount.fulfilled, (state, action) => {
        state.schoolsLoading = false;
        state.checkFilterCityCountData =
          action.payload.checkFilterCityCountData || [];
        state.actionFlag = action.payload.actionFlag || "";
        state.successMessage = action.payload.successMessage || "";
        state.errorMessage = action.payload.error || "";
      })
      .addCase(checkFilterCityCount.rejected, (state, action) => {
        state.schoolsLoading = false;
        state.schoolsError = action.payload || "Failed to fetch schools";
      })
      .addCase(searchSessionId.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
        state.isSuccess = false;
        state.errorMessage = "";
      })
      .addCase(searchSessionId.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.searchSessionId = action.payload.searchSessionIdSuccess || "";
        state.errorMessage = "";
      })
      .addCase(searchSessionId.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.errorMessage = action.payload;
      })
      .addCase(searchAnalytics.fulfilled, (state, action) => {
        state.searchAnalyticsItems =
          action.payload.searchAnalyticsSuccess || "";
      })
      .addCase(trackCityClick.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
        state.isSuccess = false;
        state.errorMessage = "";
      })
      .addCase(trackCityClick.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.trackCityClickItems = action.payload.trackCityClickSuccess || "";
        state.errorMessage = "";
      })
      .addCase(trackCityClick.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.errorMessage = action.payload;
      })
      .addCase(searchSessionEnd.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
        state.isSuccess = false;
        state.errorMessage = "";
      })
      .addCase(searchSessionEnd.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.searchSessionEndItems =
          action.payload.searchSessionEndSuccess || "";
        state.errorMessage = "";
      })
      .addCase(searchSessionEnd.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.errorMessage = action.payload;
      })
      .addCase(searchBookmark.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
        state.isSuccess = false;
        state.errorMessage = "";
      })
      .addCase(searchBookmark.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.searchBookmarkItems = action.payload.searchBookmarkSuccess || "";
        state.errorMessage = "";
      })
      .addCase(searchBookmark.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.errorMessage = action.payload;
      })
      .addCase(checkMultipleBookmarks.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
        state.isSuccess = false;
        state.errorMessage = "";
      })
      .addCase(checkMultipleBookmarks.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.checkMultipleBookmarksItems = action.payload.data || {};
        state.errorMessage = "";
      })
      .addCase(checkMultipleBookmarks.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.errorMessage = action.payload;
      })
      .addCase(getBookmarks.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
        state.isSuccess = false;
        state.errorMessage = "";
      })
      .addCase(getBookmarks.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.getBookmarksItems = action.payload.data || {};
        state.errorMessage = "";
      })
      .addCase(getBookmarks.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.errorMessage = action.payload;
      });
  },
});

export const { resetSearchState } = searchSlice.actions;
export default searchSlice.reducer;
